import styled, { css } from 'styled-components';
import { media, remCalc, layout } from 'src/components/base';
import { zindex } from 'src/ui/zindex';

export const flexStyle = css`
  min-width: 0;
  flex: 1 1 auto;

  ${media.largeUp`
    flex: 1 1 0%;
  `};
`;

export const dividerStyle = css`
  margin-top: ${layout.measurements.spacing200};

  ${media.mediumDown`
    margin-top: ${layout.measurements.spacing050};
  `};
`;

type FiltersProps = { $show?: boolean };

export const StyledFilters = styled.div<FiltersProps>(
  props => css`
    h6 {
      font-size: 14px;
      font-weight: 600;
      padding: 0;
      margin: 0;
      margin-bottom: 10px;
    }

    ${media.mediumDown`
    display: none;
    position: fixed;
    overflow: scroll;
    top: 0;
    bottom: 0;
    background: white;
    left: 0;
    right: 0;
    z-index: ${zindex.menu.filter};
    padding: 0;

    h2 {
      display: none;
    }

    ${
      props.$show &&
      css`
        display: block;
      `
    }
  `};
  `
);

export const StyledFilter = styled.div`
  padding-bottom: 10px;
  margin-bottom: 10px;
  border-bottom: 1px solid ${p => p.theme.lines.secondary};
  &:last-child {
    border-bottom: 0;
  }

  ${media.mediumDown`
    margin: 0;
    padding-top: 120px;
    padding-bottom: 60px;
    border-bottom: none;
  `};
`;

export const StyledFilterContent = styled.div`
  ${media.mediumDown`
    padding-left: ${layout.margins.wrapper.mobile.rem};
    padding-right: ${layout.margins.wrapper.mobile.rem};
  `};
`;

export const StyledFiltersHeader = styled.div`
  display: none;
  h4 {
    text-align: left;
    padding: 0 ${layout.margins.wrapper.mobile.rem};
    margin-bottom: 0;
    height: 40px;
    line-height: 40px;
    flex: auto;
    button {
      height: 40px;
      width: 40px;
      float: right;
      cursor: pointer;
    }
  }

  ${media.mediumDown`
    display: flex;
    flex-wrap: wrap;
    justify-content: space-around;
    border-bottom: 1px solid ${p => p.theme.lines.primary};
    position: fixed;
    z-index: 10; /* To cover UI elements with abs position (ex. range slider) */
    top: 0;
    left: 0;
    width: 100%;
    background-color: ${p => p.theme.bg.primary};
  `};
`;

export const StyledFiltersButton = styled.div`
  display: none;

  ${media.mediumDown`
    display: flex;
    z-index: 10; /* To cover UI elements with abs position (ex. range slider) */
    width: 100%;
    padding: ${layout.margins.component.mobile.rem};

    button {
      flex: auto;
    }
  `};
`;

export const StyledFiltersPopular = styled.div`
  display: block;
  padding: ${layout.margins.wrapper.desktop.rem};
  margin-top: ${layout.margins.component.desktop.rem};
  margin-bottom: ${layout.margins.component.desktop.rem};
  background-color: ${props => props.theme.colors.base100};

  a {
    display: block;
    margin-right: ${layout.measurements.spacing100};
    margin-bottom: ${layout.measurements.spacing050};
    text-decoration: underline;
  }

  ${media.mediumDown`
    padding: ${layout.margins.wrapper.mobile.rem};
    margin-top: ${layout.margins.component.mobile.rem};
    margin-bottom: ${layout.margins.component.mobile.rem};

    h6 {
      text-align: left;
      font-size: ${layout.measurements.fontSizeNormal};
    }
    a {
      display: inline-block;
      margin-right: 15px;
      margin-bottom: 2px;
    }
  `};
`;

type FiltersWrapperProps = { $show?: boolean };

export const StyledFiltersWrapper = styled.section<FiltersWrapperProps>(
  props => css`
    ${flexStyle}
    max-width: 220px;
    padding-right: ${remCalc(11)};

    ${media.mediumDown`
    min-width: 100%;
    display: none;

    ${
      props.$show &&
      css`
        display: block;
      `
    }
  `};
  `
);

export const StyledFilterRanges = styled.div`
  ${dividerStyle}
`;

export const StyledFilterShowButton = styled.div`
  display: none;

  ${media.mediumDown`
    display: inline-block;
    margin-right: ${layout.measurements.spacing050};
  `};
`;

export const StyledSearch = styled.div`
  display: flex;
  margin-top: ${layout.measurements.spacing125};
`;

export const StyledTags = styled.div`
  width: 100%;
  margin-top: ${layout.measurements.spacing050};

  & > * {
    margin-right: ${layout.measurements.spacing025};
    margin-bottom: ${layout.measurements.spacing025};
  }

  ${media.mediumDown`
    display: flex;
    flex-wrap: wrap;
    margin-top: ${layout.margins.wrapper.mobile.rem};
    padding-bottom: ${layout.measurements.spacing050};
    width: 100%;

    &:empty{
      display: none;
    }
    `}
`;
